import { Alert, AlertDescription, AlertTitle, Button } from '@devizy/ui';
import { EnvelopeSimpleOpen } from '@phosphor-icons/react';
import { Link, createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { ResendVerificationButton } from '@/components/auth/resend-verification-button';

export const Route = createFileRoute('/_auth/check-email')({
  validateSearch: (search: Record<string, unknown>): { email?: string } => {
    const email = typeof search.email === 'string' ? search.email : undefined;
    return email ? { email } : {};
  },
  component: CheckEmailPage,
});

function CheckEmailPage(): React.ReactElement {
  const { email } = Route.useSearch();
  return (
    <section className="border-border bg-card rounded-2xl border p-8 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)]">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="bg-primary/10 text-primary grid h-12 w-12 place-items-center rounded-full">
          <EnvelopeSimpleOpen weight="bold" className="h-6 w-6" />
        </div>
        <h1 className="font-display text-2xl tracking-tight">Vérifiez votre email</h1>
        <p className="text-muted-foreground text-sm">
          {email
            ? `Un lien de confirmation a été envoyé à ${email}.`
            : 'Un lien de confirmation a été envoyé à votre adresse.'}
        </p>
      </div>
      <div className="mt-8 space-y-4">
        <Alert>
          <AlertTitle>Compte en attente de vérification</AlertTitle>
          <AlertDescription>
            Votre compte reste <strong>en attente</strong> tant que l&apos;email n&apos;est pas
            confirmé. Le lien expire dans 24 heures. Vérifiez votre dossier spam si vous ne le voyez
            pas.
          </AlertDescription>
        </Alert>
        {email ? <ResendVerificationButton email={email} /> : null}
        <Button asChild variant="ghost" className="w-full">
          <Link to="/sign-in">Retour à la connexion</Link>
        </Button>
      </div>
    </section>
  );
}
